import TabPanel, {Tab} from '../../components/TabPanel'

import CollectorDotEnvSingleECS from './_04_setting_env_vars_single_ecs.mdx';
import CollectorDotEnvMultiECS from './_04_setting_env_vars_multi_ecs.mdx';

<TabPanel>
  <Tab id="single" label="Single DB Instance" textContent>
    <CollectorDotEnvSingleECS apiKey={props.apiKey} />
  </Tab>
  <Tab id="multiple" label="Multiple DB Instances" textContent>
    <CollectorDotEnvMultiECS apiKey={props.apiKey} />
  </Tab>
</TabPanel>
